import type { FunctionComponent, ReactNode } from 'react';

import { WithTooltip } from '@dr.pogodin/react-utils';

import type { ArtistStatusT, BlogItemStatusT, VideoStatusT } from 'utils';

import S from './style.scss';

import tooltipTheme from './tooltip.scss';

type StatusT = ArtistStatusT | BlogItemStatusT | VideoStatusT;

function getLabel(status: StatusT): string {
  switch (status) {
    case 'Active':
    case 'Deleted':
    case 'Draft':
    case 'Hidden':
    case 'Inactive':
    case 'Incomplete Application':
    case 'Pending Verification':
    case 'Published':
      return status;

    case 'DELETED': return 'Deleted';
    case 'DRAFT': return 'Draft';
    case 'PUBLISHED': return 'Published';
    case 'SCHEDULED': return 'Scheduled';

    default: throw Error('Unexpected case');
  }
}

function getStatusClassName(status: StatusT): string {
  switch (status) {
    case 'Active':
    case 'PUBLISHED':
    case 'Published':
      return S.active;

    case 'DELETED':
    case 'Deleted':
      return S.removed;

    case 'DRAFT':
    case 'Draft':
    case 'Incomplete Application':
    case 'Pending Verification':
      return S.pendingVerification;

    case 'Hidden':
    case 'Inactive':
    case 'SCHEDULED':
      return S.inactive;

    default: throw Error('Unexpected case');
  }
}

type PropsT = {
  status: StatusT;
  warning?: ReactNode;
};

const Status: FunctionComponent<PropsT> = ({ status, warning }) => (
  <div className={`${S.container} ${getStatusClassName(status)}`}>
    {getLabel(status)}
    {warning ? (
      <WithTooltip theme={tooltipTheme} tip={warning}>
        <div>!</div>
      </WithTooltip>
    ) : null}
  </div>
);

export default Status;
